import API from "./api.utils";

const env = process.env.REACT_APP_ENV === "production" ? "prod" : "dev";

const api = new API(env, { timeout: 40000 })
  .setAPIKey(process.env.API_KEY)
  .setCamelCaseTransformer(false);

export default api;
